import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";

export default function ShareButton({ url, title, label = "Share", className = "", testId = "share-button" }) {
  const [copied, setCopied] = useState(false);

  const onShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch { /* user cancelled — fall through to copy */ }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Share link copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy link");
    }
  };

  return (
    <Button data-testid={testId} onClick={onShare} variant="outline"
      className={`border-white/20 text-white bg-[#11241b] hover:bg-[#00A86B]/15 ${className}`}>
      {copied ? <Check className="w-4 h-4 mr-1.5 text-[#00A86B]" /> : <Share2 className="w-4 h-4 mr-1.5" />}
      {label}
    </Button>
  );
}
